import { render, staticRenderFns } from "./PrePostContact.vue?vue&type=template&id=1c5ea868"
import script from "./PrePostContact.vue?vue&type=script&lang=js"
export * from "./PrePostContact.vue?vue&type=script&lang=js"
import style0 from "./PrePostContact.vue?vue&type=style&index=0&id=1c5ea868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports